import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "./AuthService";
import "./ResetPassword.css";

export default function ResetPassword(){

  const { token } = useParams();
  const nav = useNavigate();
  const [password,setPassword] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    await resetPassword(token,password);
    nav("/login");
  };

  return (
    <div className="reset-password-page">
      <div className="card reset-password-card">

        <div className="reset-password-header">
          <h2>Reset Password</h2>
          <p className="reset-password-subtitle">Create a new secure password</p>
        </div>

        <form onSubmit={submit} className="form-grid reset-password-form-grid">
          <input
            className="input"
            type="password"
            placeholder="New Password"
            onChange={e=>setPassword(e.target.value)}
            required
          />

          <button className="btn btn-primary" type="submit">
            Reset Password
          </button>
        </form>

      </div>
    </div>
  );
}
